import { FunctionComponent } from 'react';
import {
  Avatar,
  Typography,
  Box,
  ListItemText,
  ListItemAvatar,
  Button,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import dummyImage from 'assets/images/dummyImage.png';
import { timeAgo } from 'utils/utility';
// @ts-ignore
import { getConfig } from '@edx/frontend-platform';
import {
  NOTIFICATION_TYPES,
  APPROVAL_REQUEST_STATUS,
} from 'constant';
import { useUpdateUnreadNotificationMutation } from 'api/notificationApi';
import { useNotifications } from 'components/NotificationsMenu/useNotifications';
import { useDispatch } from 'react-redux';
import { markNotificationRead } from './ducks/slice';
import {
  NotificationList,
  NotificationListItem,
  NotificationHeader,
} from './style';

const NotificationItem: FunctionComponent<any> = ({ notification, shouldOpenModal }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    notificationText,
    redirectRoute,
    notificationType,
    isSenderReceiver,
    displayName,
    status,
    shouldRedirectToToastmasterWebsite,
    isDeleted,
    hasOpenAction,
  } = useNotifications(notification, shouldOpenModal);
  const [updateUnReadNotifications] = useUpdateUnreadNotificationMutation();
  const toastmasterWebsiteUrl = () => getConfig().TOASTMASTERS_WEBSITE_URL;
  const lmsBaseUrl = () => getConfig().LMS_BASE_URL;

  const handleClick = () => {
    if (notification.unread) {
      updateUnReadNotifications(notification.slug).then(() => {
        dispatch(markNotificationRead(notification.slug));
      });
    }

    if (status === APPROVAL_REQUEST_STATUS.Reversed) {
      toast.info(
        `The request has become obsolete. The learner's progress may have been reversed. For further information, please reach out to our support team.`,
      );

      return;
    }

    if (shouldRedirectToToastmasterWebsite) {
      window.location.assign(`${toastmasterWebsiteUrl()}start-pathways/select-your-preference`);

      return;
    }

    if (!redirectRoute) {
      return;
    }

    if (
      NOTIFICATION_TYPES.pathwaysMentorProgramEnrollment === notificationType ||
      NOTIFICATION_TYPES.clubCoachModuleEnrollment === notificationType ||
      NOTIFICATION_TYPES.preCourseEnrollment === notificationType ||
      NOTIFICATION_TYPES.courseInactivity === notificationType ||
      NOTIFICATION_TYPES.courseEnrollment === notificationType ||
      (NOTIFICATION_TYPES.completionReview === notificationType && notification?.target?.status !== 'Denied') ||
      (notificationType === NOTIFICATION_TYPES.completionReviewNotifyBCM &&
        isSenderReceiver) ||
      NOTIFICATION_TYPES.speechcrafterCertificate === notificationType
    ) {
      window.location.assign(redirectRoute);
      return;
    }
    navigate(redirectRoute);
  };

  const canOpenNotification = hasOpenAction && !isDeleted;

  const courseImageNotificationTypes = [NOTIFICATION_TYPES.pathwaysMentorProgramEnrollment,
    NOTIFICATION_TYPES.courseInactivity, NOTIFICATION_TYPES.completionRequestSecondReminder, NOTIFICATION_TYPES.completionRequestFirstReminder, NOTIFICATION_TYPES.preCourseEnrollment,
    NOTIFICATION_TYPES.completionReview, NOTIFICATION_TYPES.completionRequest, NOTIFICATION_TYPES.courseEnrollment, NOTIFICATION_TYPES.completionReviewNotifyBCM];

  
  return (
    <NotificationList
      role='menuitem'
      className={notification.unread ? 'unread-item' : 'read-item'}
      onClick={canOpenNotification ? handleClick : () => {}}
      // @ts-ignore
      canOpenNotification={canOpenNotification}
    >
      <NotificationListItem>
        <ListItemAvatar>
          <Avatar
            aria-hidden={true}
            role='img'
            alt='user image'
            src={
              courseImageNotificationTypes.includes(notificationType)
                ? lmsBaseUrl() + notification?.target?.courseImage
                : notification?.sender?.memberPhotoUrl
            }
            onError={({ currentTarget }: any) => {
              currentTarget.onerror = null;
              currentTarget.src = dummyImage;
            }}
          />
        </ListItemAvatar>
        <ListItemText
          primary={
            <>
              <Box className=''>
                <NotificationHeader>
                  <Typography
                    variant='h4'
                    component='span'
                    className='fw-700 text-capitalize'
                  >
                    {displayName}
                  </Typography>{' '}
                  {' - '}
                  <Typography variant='h4' component='span' className='fw-700'>
                    {timeAgo(notification.timestamp)}
                  </Typography>
                </NotificationHeader>
                <Box>
                  <div
                    dangerouslySetInnerHTML={{ __html: notificationText }}
                  ></div>
                </Box>
              </Box>
            </>
          }
          sx={{ paddingTop: 1.5 }}
        />
        {canOpenNotification ? (
          <Button className='notify-btn' variant='outlined' tabIndex={-1}>
            Open
          </Button>
        ) : null}
      </NotificationListItem>
    </NotificationList>
  );
};

export default NotificationItem;
